import {useEffect, useState} from "react";
import {ProjectAPI} from "@brg/api";

export const useGetProject = (projectId: string, t?: any) => {

    const [project, setProject] = useState<any>(undefined);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [error, setError] = useState<boolean | number>(false);

    useEffect(() => {
        if (projectId) {
            setIsLoading(true);
            ProjectAPI.Get({ idProject: projectId })
                .then((r) => {
                    if (r.status !== 200) {
                        setError(r.status);
                    }
                    return r.json()
                })
                .then((r) => {
                    setIsLoading(false);
                    setProject(r)
                })
                .catch((e) => {
                    setIsLoading(false);
                    setError(true);
                })
        }
    }, [projectId, t])

    return {project, isLoading, error}
}import {useEffect, useState} from "react";
import {ProjectAPI} from "@brg/api";

export const useGetProject = (projectId: string, t?: any) => {

    const [project, setProject] = useState<any>(undefined);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [error, setError] = useState<boolean | number>(false);

    useEffect(() => {
        if (projectId) {
            setIsLoading(true);
            ProjectAPI.Get({ idProject: projectId })
                .then((r) => {
                    if (r.status !== 200) {
                        setError(r.status);
                    }
                    return r.json()
                })
                .then((r) => {
                    setIsLoading(false);
                    setProject(r)
                })
                .catch((e) => {
                    setIsLoading(false);
                    setError(true);
                })
        }
    }, [projectId, t])

    return {project, isLoading, error}
}